/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Emails1/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Emails from './Emails/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Emails1({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CommsEmail/Emails"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 marginBottom={dtSpaceS}
 fontSize={15}
 text="Email list"
/>
<Emails
  viewPath={`${viewPath}/Emails`}
/>
{children}
</React.Fragment>)
}